import React from 'react';
import { Dropdown } from 'primereact/dropdown';

import GlobalTooltip from 'components/GlobalTooltip';
import { automationStatusFilter } from 'constants/dropdownOptions';
import { usePracticeAreaList } from 'hooks/usePracticeAreaList';

export default function Filter(props) {
  const { practiceAreaList, isPracticeAreaLoading } = usePracticeAreaList();
  const { filter, refreshList, filterOnChange } = props;
  return (
    <div className="d-inline-flex filter-wrap autowidth">
      <div>
        <span className="p-input-icon-left input-shadow"></span>
      </div>
      <div className="d-flex align-items-center autowidth">
        <div className="d-flex align-items-center p-2 automation-filter filter-wraper">
          <span className="text-bold black-600 me-2">Filters: </span>

          <Dropdown
            value={filter?.practice_area}
            options={practiceAreaList}
            onChange={filterOnChange}
            placeholder="By Practice Area"
            className="me-2"
            isFilter={true}
            name="practice_area"
            optionValue="practice_area_id"
            optionLabel="practice_area_name"
            dropdownIcon={isPracticeAreaLoading ? 'pi pi-spin pi-spinner' : undefined}
          />
          <Dropdown
            value={filter?.automation_status}
            options={automationStatusFilter}
            onChange={filterOnChange}
            placeholder="By Status"
            name="automation_status"
            isFilter={false}
          />

          <div className="pointer ms-0 p-2">
            <GlobalTooltip tooltip="Clear Filter" position="top" target=".fa-sync-alt" showDelay={500}>
              <i className="fas fa-sync-alt" onClick={() => refreshList()}></i>
            </GlobalTooltip>
          </div>
        </div>
      </div>
    </div>
  );
}
